export default __webpack_public_path__ + "static/media/sharif-logo.efd76809.jpeg";